/* C-06 Money readout. */
.stack {
  display: grid;
  gap: 2px;
  justify-items: start;
}
.row {
  justify-items: end;
  text-align: right;
}
.secondary {
  color: var(--color-text-secondary);
}
.planned {
  padding: 3px 6px;
  color: var(--color-text-tertiary);
  border: 1px dashed var(--color-border-control);
}
